export default __webpack_public_path__ + "static/media/s-7.a9ce3861.jpg";